<template>
  <ion-page>
    <ion-header :translucent="true">
      <ion-toolbar>
        <ion-title>PWeatherA</ion-title>
      </ion-toolbar>
    </ion-header>
    
    <ion-content :fullscreen="true">
      <ion-header collapse="condense">
        <ion-toolbar>
          <ion-title size="large">PWeatherA</ion-title>
        </ion-toolbar>
      </ion-header>
    
      <ion-grid>
        <ion-row>
          <ion-col size-xs="12" size-sm="12" size-md="6" size-lg="6" size-xl="4">
            <ion-card>
              <ion-img :src="weather.image" />
              <ion-card-header>
                <ion-row>
                  <ion-col size-xs="12" size-sm="12" size-md="12">
                    <img :src="weather.icon" />
                    <ion-card-title>{{weather.weather[0].main}} - {{weather.weather[0].description}}</ion-card-title>
                  </ion-col>
                  <ion-col size-xs="12" size-sm="12" size-md="12">
                    <ion-card-title>{{weather.name}}</ion-card-title>
                    <p>Photo by <a :href="weather.image_user_link">{{weather.image_user}}</a> on <a href="https://unsplash.com/?utm_source=weather_pwa&utm_medium=referral">Unsplash</a></p>
                  </ion-col>
                </ion-row>
              </ion-card-header>
            </ion-card>
          </ion-col>
          <ion-col size-xs="12" size-sm="12" size-md="6" size-lg="6" size-xl="4">
            <ion-card color="primary">
              <ion-card-content>
                <p><b>Sunrise:</b> {{weather.sys.sunrise}} AM</p>
                <p><b>Sunset:</b> {{weather.sys.sunset}} PM</p>
                <hr/>
                <p><b>Humidity:</b> {{weather.main.humidity}}</p>
                <p><b>Pressure:</b> {{weather.main.pressure}}</p>
                <p><b>Temperature:</b> {{weather.main.temp}} <span v-if="units == 'metric'">degrees</span><span v-else>farenheit</span></p>
                <hr/>
                <p><b>Wind Speed:</b> {{weather.wind.speed}} <span v-if="units == 'metric'">km/h</span><span v-else>mph</span></p>
              </ion-card-content>
            </ion-card>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
    <ion-footer>
      <ion-toolbar>
        <ion-item>
          <ion-icon position="fixed" :icon="searchOutline"></ion-icon>
          <ion-input clearInput enterkeyhint="enter" inputmode="text" v-model="search" placeholder="Search Location"></ion-input>
          <ion-button @click="getWeather()" size="medium">Search</ion-button>
        </ion-item>
      </ion-toolbar>
    </ion-footer>
  </ion-page>
</template>

<script>
import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonInput } from '@ionic/vue';
import { searchOutline } from 'ionicons/icons';
import { defineComponent } from 'vue';
import axios from 'axios';

export default defineComponent({
  name: 'Home',
  components: {
    IonContent,
    IonHeader,
    IonPage,
    IonTitle,
    IonToolbar,
    IonInput
  },
  data () {
    return {
      search: 'london',
      units: 'metric',
      weather: {
        icon: '',
        image_user: '',
        image_user_link: '',
        sys: {
          sunrise: '',
          sunset: ''
        },
        main: {
          humidity: '',
          temp: '',
          pressure: ''
        },
        weather: [{
          main: '',
          description: ''
        }],
        wind: {
          speed: ''
        }
      }
    }
  },
  created() {
    this.getWeather();
  },
  methods: {
    getWeather() {
      axios.get("https://api.openweathermap.org/data/2.5/weather?q="+this.$data.search+"&units="+this.$data.units+"&appid=67f2a85a168a8605634f2de00153351e")
      .then(response => {
        this.$data.weather = response.data;
        this.$data.weather.icon = "https://openweathermap.org/img/wn/"+response.data.weather[0].icon+".png";
        this.$data.weather.sys.sunrise = this.time(response.data.sys.sunrise);
        this.$data.weather.sys.sunset = this.time(response.data.sys.sunset);
        this.getImage();
      })
      .catch(err => {
        console.log('error', err);
      });
    },
    getImage() {
      axios.get("https://api.unsplash.com/search/photos?client_id=zV4hQ5Xk5F_csVmwsin5hGOLEQvHSrKemOqFUoUtyAk&page=1&per_page=1&orientation=squarish&query="+this.$data.weather.weather[0].description)
      .then(response => {
        this.$data.weather.image = response.data.results[0].urls.small;
        this.$data.weather.image_user = response.data.results[0].user.name;
        this.$data.weather.image_user_link = response.data.results[0].user.links.html+"?utm_source=weather_pwa&utm_medium=referral";
      })
      .catch(err => {
        console.log('error', err);
      });
    },
    time(time) {
      let unix_timestamp = time;
      // Create a new JavaScript Date object based on the timestamp
      // multiplied by 1000 so that the argument is in milliseconds, not seconds.
      var date = new Date(unix_timestamp * 1000);
      // Hours part from the timestamp
      var hours = date.getHours();
      // Minutes part from the timestamp
      var minutes = "0" + date.getMinutes();
      // Seconds part from the timestamp
      var seconds = "0" + date.getSeconds();

      // Will display time in 10:30:23 format
      var formattedTime = hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);
      return formattedTime;
    }
  },
  setup() {
    return {
      searchOutline
    }
  }
});
</script>

<style scoped>
  ion-card-header {
    position: absolute;
    bottom: 0;
    width: 100%;
    text-align: center;
    background: #000000a6;
    color: white;
  }
  ion-card-header ion-card-title {
    color: white;
  }
  ion-footer ion-icon {
    padding-right: 20px;
  }
</style>